<template>
  <form @submit.prevent="submitHandler">

    <div class="alert alert-danger text-center" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">{{$t("Email")}}:</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': (!$v.formData.email.required && $v.formData.email.$dirty) || !$v.formData.email.email }]"
          @blur="$v.formData.email.$touch()"
          v-model="formData.email">
        <div class="invalid-feedback">
          {{ $v.formData.email.required ? 'Please, enter valid email' : 'Please, enter email' }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">{{$t("Password")}}:</label>
      <div class="col-sm-10">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.password.required && $v.formData.password.$dirty }]"
          @blur="$v.formData.password.$touch()"
          v-model="formData.password">
        <div class="invalid-feedback">
          Please, enter password.
        </div>
      </div>
    </div>

    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="$v.formData.$invalid">{{$t("loginFormSubmit")}}</button>

    <loading :loading="loading"></loading>

  </form>
</template>


<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  validations: {
    formData: {
      password: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  data() {
    return {
      formData: {
        password: null,
        email: null,
      },
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    submitHandler() {
      if (!this.$v.formData.$invalid) {
        this.loading = true
        this.$store.dispatch('login', this.formData)
          .then(() => {
            this.$emit('loginSuccess')
          })
          .catch(errRes => {
            if (errRes.wrongAppErr) {
              this.errMsg = this.$t('noUserErr')
            } else {
              this.errMsg = this.$t(errRes.error)
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/forms/LoginForm.vue